import { createSlice } from "@reduxjs/toolkit";

const sendingSlice = createSlice({
  name: "sendingStatus",
  initialState: {
    sending: {
      isSending: false,
      sent: false,
      isTyping: false,
    },
  },
  reducers: {
    setIsSending: (state, action) => {
      state.sending.isSending = action.payload;
    },
    setSent: (state, action) => {
      state.sending.sent = action.payload;
    },
    setTyping: (state, action) => {
      state.sending.isTyping = action.payload;
    },
  },
});

export const { setIsSending, setSent, setTyping } = sendingSlice.actions;
export default sendingSlice.reducer;
